import { httpClient, unwrap } from './httpClient';

export async function getAkBackendHealth() {
  const response = await httpClient.get('/admin/overview/ak-backend');
  return unwrap(response);
}

export async function getAkCloneStatus() {
  const response = await httpClient.get('/admin/overview/ak-clone');
  return unwrap(response);
}

export async function getAkResourcesStatus() {
  const response = await httpClient.get('/admin/overview/ak-resources');
  return unwrap(response);
}

export async function getKctGeneralStatus() {
  const response = await httpClient.get('/admin/overview/kct-general');
  return unwrap(response);
}

const adminOverviewService = {
  getAkBackendHealth,
  getAkCloneStatus,
  getAkResourcesStatus,
  getKctGeneralStatus,
};

export default adminOverviewService;
